<template>
  <v-table
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :push-list="RouteConfig.teacherList.push"
    :query-list="queryList"
    :is-show-store-select="true"
    :is-store-select-clearable="true"
    :is-show-search-input="true"
  >
    <el-table-column width="70px" label="ID" prop="id"/>

    <v-column-time/>

    <v-column-admin v-if="isAdministrator" label="添加者"/>

    <v-column-avatar :link-page-name="RouteConfig.teacherDetail.name"/>

    <el-table-column label="所属门店" prop="store_names"/>

    <el-table-column label="手机号" prop="phone"/>

    <el-table-column label="企业微信号" prop="we_chat"/>

    <el-table-column label="微博号" prop="micro_blog"/>

    <el-table-column label="美拍号" prop="mei_pai"/>

    <el-table-column label="操作" :width="isAdministrator ? '410px' : '310px'">
      <template v-slot="{ row }">
        <v-list-button name="修改资料" size="large" :to="RouteConfig.teacherEdit.to(row.id)"/>

        <v-list-button
          v-if="isReceptionist && !row.is_include"
          name="加入本店"
          size="large"
          @click="saveTeacherToStore(row)"
          :is-loading="isSaving[row.id]"
          message="加入本店后需要由店长设置薪资，确认要将老师加入至本店吗？"
        />

        <v-list-button
          v-if="isAdministrator || (isManager && !row.is_include)"
          :name="`加入${isAdministrator ? '门' : '本'}店`"
          size="large"
          :to="RouteConfig.teacherSalaryAdd.to(row.id)"
        />

        <v-list-button
          v-if="isManagerOrReceptionist && row.is_include"
          name="移出本店"
          size="large"
          @click="deleteTeacherFromStore(row)"
          :is-loading="isSaving[row.id]"
          message="移除后将无法恢复薪资数据，确定要移除吗？"
        />

        <v-popover>
          <v-popover-item
            v-if="isAdministrator"
            name="删除老师"
            icon="bin"
            @click="handleDelete(row.id)"
            :is-loading="isDeleting[row.id]"
            message="删除老师后需要手动删除相关课程，确认要删除该老师吗？"
          />
          <v-popover-item icon="mini-app-qr-code" name="小程序码" @click="getQrCode(row.id)" :is-loading="isGetting[row.id]"/>
        </v-popover>

      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`teacher-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>昵称</span>
              <v-avatar-nickname
                :value="v.avatar"
                :nickname="v.nickname"
                :is-center="true"
                :nickname-overflow="true"
                :link-page-name="RouteConfig.teacherDetail.name"
                :link-page-id="v.id"
                :avatar-size="50"
                width="30vw"
              />
            </div>

            <div v-if="isAdministrator" class="list-item-detail">
              <span>添加者</span>
              <v-avatar-nickname
                :value="v.administrator_avatar"
                :nickname="v.administrator_nickname"
                :is-center="true"
                :nickname-overflow="true"
                :avatar-size="50"
                width="30vw"
              />
            </div>

            <div class="list-item-detail">
              <span>ID</span>
              <span>{{ v.id | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>所属门店</span>
              <span>{{ v.store_name || '' }}</span>
            </div>

            <div class="list-item-detail">
              <span>手机号</span>
              <span>{{ v.phone || '' }}</span>
            </div>

            <div class="list-item-detail">
              <span>企业微信号</span>
              <span>{{ v.we_chat || '' }}</span>
            </div>

            <div class="list-item-detail">
              <span>微博号</span>
              <span>{{ v.micro_blog || '' }}</span>
            </div>

            <div class="list-item-detail">
              <span>美拍号</span>
              <span>{{ v.mei_pai || '' }}</span>
            </div>

            <div class="list-item-button">
              <v-list-button name="修改资料" size="large" :to="RouteConfig.teacherEdit.to(v.id)"/>

              <v-list-button
                v-if="isReceptionist && !v.is_include"
                name="加入本店"
                size="large"
                @click="saveTeacherToStore(v)"
                :is-loading="isSaving[v.id]"
                message="加入本店后需要由店长设置薪资，确认要将老师加入至本店吗？"
              />

              <v-list-button
                v-if="isAdministrator || (isManager && !v.is_include)"
                :name="`加入${isAdministrator ? '门' : '本'}店`"
                size="large"
                :to="RouteConfig.teacherSalaryAdd.to(v.id)"
              />

              <v-list-button
                v-if="isManagerOrReceptionist && v.is_include"
                name="移出本店"
                size="large"
                @click="deleteTeacherFromStore(v)"
                :is-loading="isSaving[v.id]"
                message="移除后将无法恢复薪资数据，确定要移除吗？"
              />

              <v-popover>
                <v-popover-item
                  v-if="isAdministrator"
                  name="删除老师"
                  icon="bin"
                  @click="handleDelete(v.id)"
                  :is-loading="isDeleting[v.id]"
                  message="删除老师后需要手动删除相关课程，确认要删除该老师吗？"
                />
                <v-popover-item icon="mini-app-qr-code" name="小程序码" @click="getQrCode(v.id)" :is-loading="isGetting[v.id]"/>
              </v-popover>
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { index, destroy, getQrCode } from '@/api/teacher';
import { store as saveTeacherFromStore, destroyByTeacherId } from '@/api/store-teacher';
import { getLegalQueryList } from '@/utils/formats';

export default {
  name: RouteConfig.teacherList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isSaving: {},
    isDeleting: {},
    queryList: {
      keyword: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
    count: 0,
    list: [],
    isGetting: [],
  }),
  computed: {
    ...mapGetters([
      'isMobile',
      'isAdministrator',
      'isManager',
      'isReceptionist',
      'isManagerOrReceptionist',
      'defaultStoreId',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    refresh() {
      RouteConfig.teacherList.push(this.queryList);
    },
    handleStoreChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    handlePageChange({ page, size }) {
      this.queryList.page = page;
      this.queryList.size = size;
      this.refresh();
    },
    async load(route = this.$route, next) {
      const { queryList } = this;
      queryList.store_id = this.defaultStoreId;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;

      if (next) next();
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
    },
    async saveTeacherToStore({ id }) {
      this.$set(this.isSaving, id, true);
      const { isError } = await saveTeacherFromStore({ teacher_id: id });
      this.$set(this.isSaving, id, false);
      if (!isError) this.load();
    },
    async deleteTeacherFromStore({ id }) {
      this.$set(this.isSaving, id, true);
      const { isError } = await destroyByTeacherId({ teacher_id: id });
      this.$set(this.isSaving, id, false);
      if (!isError) this.load();
    },
    async handleDelete(id) {
      if (!id) return;
      this.$set(this.isDeleting, id, true);
      const { isError } = await destroy(id);
      this.$set(this.isDeleting, id, false);
      if (!isError) this.load();
    },
    async getQrCode(id, obj) {
      if (this.isGetting[id]) return;

      this.$set(this.isGetting, id, true);
      const { isError, data } = await getQrCode(id);
      this.$set(this.isGetting, id, false);
      if (isError) return;

      if (!data.qr_code) return;
      if (!obj) return window.open(data.qr_code);
      Object.assign(obj, { src: data.qr_code });
    },
  },
};
</script>
